<template>
  <EmptyState
    image="error"
    :imageAlt="$t('global.error')"
    :boldMessage="$t('global.error-state-generic')"
  />
</template>

<script>
import EmptyState from "@/components/display/empty-state/EmptyState";
export default {
  name: "errorState",
  components: { EmptyState },
};
</script>
